import {EventEditModeEnum, EventEditModes} from '@hconnect/common/types'
import {getFormPrimaryButtonSx} from '@hconnect/common/utils'
import {Close} from '@mui/icons-material'
import {Button, Dialog, DialogActions, DialogTitle} from '@mui/material'
import React, {useState} from 'react'
import {useTranslation} from 'react-i18next'

import {SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE} from '../../consts'

type EventEditDialogProps = {
  setEditMode: (mode: EventEditModes) => void
  isRepeating: boolean
  doClose: () => void
}

export const EventEditDialog: React.FC<EventEditDialogProps> = (props) => {
  const {setEditMode, isRepeating, doClose} = props
  const [editModeDialog, openEditModeDialog] = useState<boolean>(isRepeating)
  const {t} = useTranslation(SHIFT_EVENT_DETAILS_WIDGET_NAMESPACE)

  return editModeDialog ? (
    <Dialog open data-test-id="event-edit-selection">
      <DialogTitle>{t('shiftEvent.recurringTask.editRecurringTask')}</DialogTitle>
      <DialogActions>
        <Button
          startIcon={<Close />}
          onClick={() => {
            doClose()
            openEditModeDialog(false)
          }}
          color="primary"
          variant="text"
          data-test-id="edit-cancel"
        >
          {t('shiftEvent.action.cancel')}
        </Button>
        <Button
          onClick={() => {
            setEditMode(EventEditModeEnum.SINGLE_IN_SERIES)
            openEditModeDialog(false)
          }}
          color="secondary"
          variant="text"
          sx={getFormPrimaryButtonSx}
          data-test-id="edit-single"
        >
          {t('shiftEvent.recurringTask.editEvent')}
        </Button>
        <Button
          onClick={() => {
            setEditMode(EventEditModeEnum.SERIES)
            openEditModeDialog(false)
          }}
          color="secondary"
          variant="text"
          sx={getFormPrimaryButtonSx}
          data-test-id="edit-series"
        >
          {t('shiftEvent.recurringTask.editSeries')}
        </Button>
      </DialogActions>
    </Dialog>
  ) : null
}
